// src/App.js
import React, { useEffect } from 'react';
import './index.css';
import {
  Routes,
  Route,
  Navigate,
  useLocation
} from 'react-router-dom';

import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import HowItWorks from './components/HowItWorks';
import WhyTrustUs from './components/WhyTrustUs';
import Testimonials from './components/Testimonials';
import ContactForm from './components/ContactForm';
import About from './components/About';
// import BecomeAVendor from './components/BecomeAVendorAccordion';
import BecomeAVendor from './components/VendorPageWrapper';
import ExploreVendors from './components/ExploreVendors';
import VendorDetails from './components/VendorDetails';
import Footer from './components/Footer';


// Newly added imports for your Markdown-based blog
import BlogList from './components/BlogList';
import BlogPost from './components/BlogPost';

function App() {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-58Q3PMV18N', {
        page_path: location.pathname,
      });
    }
  }, [location]);

  return (
    <div className="font-sans">
      <Navigation />

      <Routes>
        <Route
          path="/"
          element={
            <>
              <HeroSection />
              <HowItWorks />
              <WhyTrustUs />
              <Testimonials />
            </>
          }
        />

        {/* Blog listing and posts */}
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/:slug" element={<BlogPost />} />

        {/* Explore Vendors at /vendors */}
        <Route path="/vendors" element={<ExploreVendors />} />
        {/* Optional alias */}
        <Route path="/explore-vendors" element={<ExploreVendors />} />

        {/* Vendor Details */}
        <Route path="/vendors/:id" element={<VendorDetails />} />

        {/* Become a Vendor */}
        <Route path="/become-a-vendor" element={<BecomeAVendor />} />

        {/* Contact Page */}
        <Route path="/contact" element={<ContactForm />} />

        {/* About Page */}
        <Route path="/about" element={<About />} />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <Footer />
    </div>
  );
}

export default App;